//Get Certificate Statistics
export const SEND_DASHBOARD_SUCCESS = 'SEND_DASHBOARD_SUCCESS';
export const SEND_DASHBOARD_LOADING = 'SEND_DASHBOARD_LOADING';
export const SEND_DASHBOARD_FAILURE = 'SEND_DASHBOARD_FAILURE';
export const SEND_DASHBOARD_COMPLETE = 'SEND_DASHBOARD_COMPLETE';